import { Box, ThemeProvider, Toolbar, ToolbarProps, Typography, useTheme } from "@mui/material";
import { senecColors } from "src/styles/senecBaseThemePalette";

export interface SenecToolbarProps extends ToolbarProps {
    title: string;
}

export const SenecToolbar = ({ title, children, ...rest }: SenecToolbarProps) => {
    const theme = useTheme();
    return (
        <ThemeProvider theme={theme}>
            <Toolbar
                data-testid="toolbar"
                style={{
                    padding: "16px",
                    paddingLeft: "24px",
                    borderRadius: "0.75rem",
                    background: senecColors.deepBlue,
                }}
                {...rest}
            >
                <Typography data-testid="toolbar-title" variant="body1Medium" color={senecColors.white} sx={{ flexGrow: 1 }}>
                    {title}
                </Typography>
                <Box data-testid="toolbar-children" display="flex" gap="0.75rem">
                    {children}
                </Box>
            </Toolbar>
        </ThemeProvider>
    );
};
